(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["document-page"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-doc-body]').forEach(function (body) {
      var root = body.closest('.doc-page');
      if (!root) return;

      var toc = root.querySelector('[data-doc-toc]');
      var tocList = root.querySelector('[data-doc-toc-list]');
      var tocFooter = root.querySelector('[data-doc-toc-footer]');
      var headings = Array.prototype.slice.call(body.querySelectorAll('h2, h3'));

      if (headings.length && tocList) {
        headings.forEach(function (heading, index) {
          if (!heading.id) heading.id = 'doc-section-' + (index + 1);
          var link = document.createElement('a');
          link.className = 'doc-page__toc-link';
          link.href = '#' + heading.id;

          var num = document.createElement('span');
          num.className = 'doc-page__toc-num';
          num.textContent = String(index + 1).length < 2 ? '0' + (index + 1) : String(index + 1);

          var label = document.createElement('span');
          label.textContent = heading.textContent;

          link.appendChild(num);
          link.appendChild(label);
          tocList.appendChild(link);
        });
      } else if (toc) {
        toc.hidden = true;
      }

      if (tocFooter) {
        var wordCount = (body.textContent.match(/\S+/g) || []).length;
        if (wordCount > 0) {
          var minutes = Math.max(1, Math.round(wordCount / 200));
          var unit = tocFooter.getAttribute('data-minutes-unit') || '';
          var readLine = document.createElement('div');
          readLine.textContent = (tocFooter.getAttribute('data-est-read-label') || '') + ' ' + minutes + ' ' + unit;
          var wordsLine = document.createElement('div');
          wordsLine.textContent = (tocFooter.getAttribute('data-words-label') || '') + ' ' + wordCount;
          tocFooter.appendChild(readLine);
          tocFooter.appendChild(wordsLine);
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buy-box"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-buy-box]').forEach(function (root) {
      var variantsEl = root.querySelector('[data-buy-box-variants]');
      var variants = [];
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (e) {
        variants = [];
      }
      if (!Array.isArray(variants)) return;

      // Built from single braces at runtime, never written as a literal
      // double-brace pair, since Theme Check's static-JS-block rule flags
      // that text shape anywhere in this block, string or comment alike.
      var openBrace = '{';
      var closeBrace = '}';
      var open2 = openBrace + openBrace;
      var close2 = closeBrace + closeBrace;
      var AMOUNT_TOKEN = open2 + 'amount' + close2;
      var AMOUNT_ND_TOKEN = open2 + 'amount_no_decimals' + close2;

      var moneyFormatEl = root.querySelector('[data-buy-box-money-format]');
      var moneyFormat = '$' + AMOUNT_TOKEN;
      try {
        moneyFormat = JSON.parse(moneyFormatEl.textContent) || moneyFormat;
      } catch (e) {}

      function money(cents) {
        var value = (cents / 100).toFixed(2);
        if (moneyFormat.indexOf(AMOUNT_ND_TOKEN) !== -1) {
          value = Math.round(cents / 100).toString();
          return moneyFormat.replace(AMOUNT_ND_TOKEN, value);
        }
        return moneyFormat.replace(AMOUNT_TOKEN, value);
      }

      var idInput = root.querySelector('[data-buy-box-variant-id]');
      var priceEl = root.querySelector('[data-buy-box-price]');
      var skuEl = root.querySelector('[data-buy-box-sku]');
      var stockEl = root.querySelector('[data-buy-box-stock]');
      var submitBtn = root.querySelector('[data-buy-box-submit]');
      var submitLabel = root.querySelector('[data-buy-box-submit-label]');
      var submitArrow = root.querySelector('[data-buy-box-submit-arrow]');
      var submitSep = root.querySelector('[data-buy-box-submit-sep]');
      var submitPrice = root.querySelector('[data-buy-box-submit-price]');
      var confirmation = root.querySelector('[data-buy-box-confirmation]');
      var errorEl = root.querySelector('[data-buy-box-error]');
      var form = root.querySelector('[data-buy-box-form]');
      var submissionPending = false;
      var nativeVariant = root.querySelector('select[data-buy-box-variant-id]');

      if (!nativeVariant) return;
      root.classList.add('buy-box--js');
      if (nativeVariant) nativeVariant.disabled = true;

      var selections = {};
      root.querySelectorAll('[data-buy-box-options]').forEach(function (group) {
        var kind = group.getAttribute('data-buy-box-options');
        var position = group.getAttribute('data-option-position');
        var activeBtn = group.querySelector('.buy-box__swatch--active, .buy-box__cell-btn--active');
        selections[position] = activeBtn ? activeBtn.getAttribute('data-value') : null;
        if (kind === 'size' && activeBtn) {
          document.dispatchEvent(new CustomEvent('sel:size-change', { detail: { value: activeBtn.getAttribute('data-value') } }));
        }
      });

      function findVariant() {
        return variants.filter(function (v) {
          return Object.keys(selections).every(function (position) {
            var key = 'option' + position;
            return v[key] === selections[position];
          });
        })[0] || null;
      }

      function renderSubmitState(variant) {
        if (!submitBtn || !submitLabel) return;
        var available = !!variant && variant.available;
        submitBtn.disabled = submissionPending || !available;
        submitLabel.textContent = submitLabel.getAttribute(available ? 'data-add-label' : 'data-sold-out-label') || submitLabel.textContent;
        if (submitArrow) submitArrow.hidden = !available;
        if (submitSep) submitSep.hidden = !available;
        if (submitPrice) submitPrice.hidden = !available;
      }

      function applyVariant(variant) {
        if (!variant) return;
        if (idInput) idInput.value = String(variant.id);
        if (priceEl) priceEl.textContent = money(variant.price);
        if (submitPrice) submitPrice.textContent = money(variant.price);
        if (skuEl) skuEl.textContent = variant.sku || '';
        if (stockEl) {
          var inStock = !!variant.available;
          stockEl.textContent = stockEl.getAttribute(inStock ? 'data-in-stock-label' : 'data-sold-out-label') || stockEl.textContent;
          stockEl.classList.toggle('buy-box__stock--in', inStock);
          stockEl.classList.toggle('buy-box__stock--out', !inStock);
        }
        renderSubmitState(variant);
      }

      root.querySelectorAll('[data-buy-box-options]').forEach(function (group) {
        var kind = group.getAttribute('data-buy-box-options');
        var position = group.getAttribute('data-option-position');
        var selectedValueEl = root.querySelector('[data-buy-box-selected="' + kind + '"]');

        group.querySelectorAll('[data-buy-box-option-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            group.querySelectorAll('[data-buy-box-option-value]').forEach(function (b) {
              b.classList.remove('buy-box__swatch--active', 'buy-box__cell-btn--active');
              b.setAttribute('aria-pressed', 'false');
            });
            btn.classList.add(kind === 'colour' ? 'buy-box__swatch--active' : 'buy-box__cell-btn--active');
            btn.setAttribute('aria-pressed', 'true');

            var value = btn.getAttribute('data-value');
            selections[position] = value;
            if (selectedValueEl) selectedValueEl.textContent = value;
            if (kind === 'size') {
              document.dispatchEvent(new CustomEvent('sel:size-change', { detail: { value: value } }));
            }

            applyVariant(findVariant());
          });
        });
      });

      applyVariant(findVariant());

      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          if (!idInput || !idInput.value || submissionPending) return;
          var submittedVariantId = idInput.value;
          submissionPending = true;
          renderSubmitState(findVariant());
          if (confirmation) confirmation.hidden = true;
          if (errorEl) errorEl.hidden = true;

          function addToCart() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: submittedVariantId,
                quantity: 1,
                sections: 'cart-drawer',
                sections_url: window.location.pathname,
              }),
            })
              .then(function (response) {
                return response.json().then(function (data) {
                  if (!response.ok) throw new Error(data.description || 'error');
                  return data;
                });
              })
              .then(function (addedItem) {
                // A global cart-drawer engine is expected on every page
                // (see sections/cart-drawer.liquid) - fall back to the
                // inline confirmation message only in its absence.
                if (window.SEL && window.SEL.cart) {
                  window.SEL.cart.applySections(addedItem.sections);
                  window.SEL.cart.open();
                } else if (confirmation) {
                  confirmation.hidden = false;
                }
                return fetch('/cart.js')
                  .then(function (response) {
                    if (!response.ok) throw new Error('cart count refresh failed');
                    return response.json();
                  })
                  .then(function (cart) {
                    var countEls = document.querySelectorAll('[data-cart-count]');
                    countEls.forEach(function (el) {
                      el.textContent = cart.item_count;
                      el.hidden = cart.item_count === 0;
                    });
                  })
                  .catch(function () {});
              });
          }

          var enqueue = window.SEL && window.SEL.cart && window.SEL.cart.enqueueMutation;
          var addRequest = enqueue ? enqueue(addToCart) : addToCart();

          addRequest
            .catch(function () {
              if (errorEl) {
                errorEl.textContent = errorEl.getAttribute('data-generic-error') || 'Something went wrong. Please try again.';
                errorEl.hidden = false;
              }
            })
            .finally(function () {
              submissionPending = false;
              renderSubmitState(findVariant());
            });
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-product-gallery]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
      if (slides.length < 2) return;

      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
      var prevBtn = root.querySelector('[data-gallery-prev]');
      var nextBtn = root.querySelector('[data-gallery-next]');
      var current = 0;

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.hidden = i !== current;
        });
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('product-gallery__thumb--active', i === current);
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          show(parseInt(thumb.getAttribute('data-index'), 10) || 0);
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });

      show(0);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-measurements"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('sel:size-change', function (event) {
      var value = event.detail && event.detail.value;
      document.querySelectorAll('[data-spec-size-row]').forEach(function (row) {
        row.classList.toggle('measurements__row--active', row.getAttribute('data-size') === value);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["waitlist-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'sel_waitlist_subscribed';
    var SUBMIT_TIMEOUT_MS = 10000;

    document.querySelectorAll('[data-waitlist]').forEach(function (root) {
      var formEl = root.querySelector('form');
      var fieldsWrap = root.querySelector('[data-waitlist-form]');
      var confirmation = root.querySelector('[data-waitlist-confirmation]');
      var errorBlock = root.querySelector('[data-waitlist-error]');
      var duplicate = root.querySelector('[data-waitlist-duplicate]');
      var serviceError = root.querySelector('[data-waitlist-service-error]');
      var serviceErrorText = serviceError
        ? serviceError.querySelector('[data-waitlist-service-error-text]')
        : null;
      var validationError = root.querySelector('[data-waitlist-validation-error]');
      var validationErrorText = validationError
        ? validationError.querySelector('[data-waitlist-validation-error-text]')
        : null;
      var loadingStatus = root.querySelector('[data-waitlist-loading-status]');

      function getStorage() {
        try {
          return window.localStorage;
        } catch (e) {
          return null;
        }
      }

      var storage = getStorage();

      function showServiceError(messageAttr) {
        if (!serviceError) return;
        if (serviceErrorText && messageAttr) {
          serviceErrorText.textContent = serviceError.getAttribute(messageAttr) || '';
        }
        serviceError.hidden = false;
        serviceError.focus();
      }

      // A fresh confirmation or a validation-error round-trip just happened:
      // move focus there, since a role="status"/"alert" region present at
      // page load (rather than mutated after load) isn't announced on its
      // own. Both are the direct result of something the user just did, so
      // stealing focus is appropriate here.
      if (confirmation) {
        if (storage) {
          try {
            storage.setItem(STORAGE_KEY, '1');
          } catch (e) {}
        }
        if (typeof window.umami === 'object' && window.umami && typeof window.umami.track === 'function') {
          window.umami.track('waitlist_signup');
        }
        confirmation.focus();
      } else if (errorBlock) {
        errorBlock.focus();
      } else if (fieldsWrap && duplicate && storage) {
        // No submission in progress and no error to show: check whether this
        // browser already completed a signup, and show the duplicate state
        // instead of the form if so. This can trigger on a plain, un-acted-on
        // page load, so unlike the two states above it does not steal focus.
        var alreadySubscribed = false;
        try {
          alreadySubscribed = storage.getItem(STORAGE_KEY) === '1';
        } catch (e) {}

        if (alreadySubscribed) {
          fieldsWrap.hidden = true;
          duplicate.hidden = false;
        }
      }

      if (duplicate) {
        var resetBtn = duplicate.querySelector('[data-waitlist-reset]');
        if (resetBtn) {
          resetBtn.addEventListener('click', function () {
            duplicate.hidden = true;
            if (fieldsWrap) {
              fieldsWrap.hidden = false;
              var emailInput = fieldsWrap.querySelector('input[type="email"]');
              if (emailInput) emailInput.focus();
            }
            if (storage) {
              try {
                storage.removeItem(STORAGE_KEY);
              } catch (e) {}
            }
          });
        }
      }

      if (formEl) {
        var submitBtn = formEl.querySelector('button[type="submit"]');
        var emailField = formEl.querySelector('input[type="email"]');
        var consentField = formEl.querySelector('input[type="checkbox"]');
        var originalButtonText = submitBtn ? submitBtn.textContent : '';
        var submitTimer = null;

        // Only disable the browser's native validation UI once we know this
        // script actually ran: a visitor without JS keeps the native
        // required/type="email" enforcement (including of the consent
        // checkbox) as a real fallback, rather than losing it silently.
        formEl.setAttribute('novalidate', 'novalidate');

        function hideAllErrors() {
          if (errorBlock) errorBlock.hidden = true;
          if (serviceError) serviceError.hidden = true;
          if (validationError) validationError.hidden = true;
        }

        function showValidationError(messages) {
          if (!validationError) return;
          if (validationErrorText) validationErrorText.textContent = messages.join(' ');
          validationError.hidden = false;
          validationError.focus();
        }

        function resetSubmitState() {
          if (submitTimer) {
            clearTimeout(submitTimer);
            submitTimer = null;
          }
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
            submitBtn.textContent = originalButtonText;
          }
          if (loadingStatus) loadingStatus.textContent = '';
        }

        // If the browser restores this page from the back/forward cache after
        // a submit (e.g. the user pressed Back), the disabled/loading button
        // state would otherwise persist forever with no way to retry.
        window.addEventListener('pageshow', function (event) {
          if (event.persisted) resetSubmitState();
        });

        formEl.addEventListener('submit', function (event) {
          if (submitTimer) clearTimeout(submitTimer);

          // Clear every error state up front so a stale one from a previous
          // failed attempt never sits alongside a new one.
          hideAllErrors();

          // With novalidate set (see above), the browser's automatic
          // check-and-block-and-popup no longer runs, but checkValidity()
          // still evaluates each field's own constraints correctly - this
          // shows the same messages in our own styled box, in one place,
          // instead of the browser's native per-field validation bubble.
          var messages = [];
          if (emailField && !emailField.checkValidity()) {
            var invalidMessage = emailField.getAttribute('data-invalid-message');
            if (invalidMessage) messages.push(invalidMessage);
          }
          if (consentField && !consentField.checked) {
            var requiredMessage = consentField.getAttribute('data-required-message');
            if (requiredMessage) messages.push(requiredMessage);
          }

          if (messages.length) {
            // stopImmediatePropagation matters here, not just preventDefault:
            // Shopify's own bot-protection script also listens for this
            // form's submit event (elsewhere in the page, via delegation),
            // and preventDefault alone does not stop the event from still
            // bubbling to it - without this, a submission blocked here for a
            // simple validation error was still redirecting to a captcha
            // challenge, since that listener never learns we already handled it.
            event.preventDefault();
            event.stopImmediatePropagation();
            showValidationError(messages);
            return;
          }

          if (typeof navigator.onLine === 'boolean' && !navigator.onLine) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showServiceError('data-offline-message');
            return;
          }

          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.setAttribute('aria-busy', 'true');
            var loadingText = submitBtn.getAttribute('data-loading-text');
            if (loadingText) submitBtn.textContent = loadingText;
          }
          if (loadingStatus) {
            loadingStatus.textContent = loadingStatus.getAttribute('data-submitting-text') || '';
          }

          // Native full-page submission should navigate away well before this
          // fires. If it doesn't (a blocked/failed submission that never
          // errors or redirects), recover instead of leaving the button
          // disabled and labeled "Submitting..." indefinitely.
          submitTimer = setTimeout(function () {
            resetSubmitState();
            showServiceError('data-timeout-message');
          }, SUBMIT_TIMEOUT_MS);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
